import Home from '@/views/Home'

export default [
    {
      path: '/',
      name: 'tranfr',
      component: Home,
      meta: {
        title: 'Transfr | Landing Page',
        layout: 'default'
      }
    }
  ]